// La barra de filtros del listado de observaciones (handoff listado §2):
// búsqueda, un chip por columna con conteos contra los OTROS filtros,
// «Limpiar filtros» (sólo con algún filtro activo) y «N resultados».
// Controlada: el estado vive en la URL y lo maneja quien la monta.
import { Icon } from "./icons";
import { FilterMultiDropdown } from "./FilterMultiDropdown";
import {
  CLEAR_FILTERS,
  hasActiveFilters,
  optionsFor,
  type FilaObs,
  type FilterKey,
  type ListPatch,
  type ListState,
} from "../lib/postventa/observacionesList";

export const FILTER_LABEL: Record<FilterKey, string> = {
  estado: "Estado",
  criticidad: "Criticidad",
  unidad: "Unidad",
  contratista: "Contratista",
  especialidad: "Especialidad",
  partida: "Partida",
  antiguedad: "Antigüedad",
  plazo: "Plazo",
};

export function ObservacionesFiltros({
  filas,
  state,
  keys,
  onPatch,
  resultCount,
  domains,
  labelFallbacks,
  searchPlaceholder = "Buscar observación, recinto, partida o unidad…",
}: {
  /** Todas las filas del alcance (sin filtrar): base de los conteos. */
  filas: readonly FilaObs[];
  state: ListState;
  /** Los chips a mostrar, en orden. */
  keys: readonly FilterKey[];
  onPatch: (patch: ListPatch) => void;
  /** null mientras carga o con error: el contador no se pinta. */
  resultCount: number | null;
  /** Dominio acotado de un chip (p. ej. el archivo sólo ofrece los
   *  estados terminales). */
  domains?: Partial<Record<FilterKey, readonly string[]>>;
  /** Etiqueta de un valor de la URL que no aparece en ninguna fila (un
   *  `?unidad=` de una unidad sin observaciones). */
  labelFallbacks?: Partial<Record<FilterKey, (value: string) => string | null | undefined>>;
  searchPlaceholder?: string;
}) {
  return (
    <div className="filters">
      <div className="filter-search">
        <Icon.Search />
        <input
          placeholder={searchPlaceholder}
          aria-label={searchPlaceholder.replace(/…$/, "")}
          value={state.q}
          onChange={(e) => onPatch({ q: e.target.value })}
        />
      </div>
      {keys.map((k) => (
        <FilterMultiDropdown
          key={k}
          label={FILTER_LABEL[k]}
          options={optionsFor(filas, state, k, domains?.[k], labelFallbacks?.[k])}
          value={state[k]}
          onChange={(next) => onPatch({ [k]: next })}
        />
      ))}
      {hasActiveFilters(state) && (
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          data-filter-clear=""
          onClick={() => onPatch(CLEAR_FILTERS)}
        >
          Limpiar filtros
        </button>
      )}
      <div className="filter-spacer" />
      {resultCount !== null && (
        <span className="cell-meta mono">
          {resultCount} {resultCount === 1 ? "resultado" : "resultados"}
        </span>
      )}
    </div>
  );
}
